
import React from "react";
import ReactDOM from "react-dom";
class AlertNotification extends React.Component {
    componentDidMount() {
        const that = this;
        setTimeout(() => {
            that.onClose();
        }, 7000)
    }
    onClose() {
        const AlertnotificationDOM = document.getElementById("alert-notification");
        ReactDOM.unmountComponentAtNode(AlertnotificationDOM);
    }
    render() {
        const { title, message, type } = this.props;

        return (
            <div className='AlertNotification'>
                <div className={`${type} notification`}>
                    <img
                        className="close-notification"
                        src={`${BASE.url}v4/image/notification/close.svg`}
                        onClick={() => this.onClose()}
                    />
                    <div className="icon-title">
                        <img className="icones" data-src={`${modalV4.url}/v4/image/notification/note.svg`} />
                        <p className="title">
                            {title}
                        </p>
                    </div>
                    {message
                        ?
                        <div className="message">
                            <p>{message}</p>
                        </div>
                        :
                        null
                    }
                </div>
            </div>
        );
    }
}

export function showNotification({ title, message, type }) {
    const Alertnotification = document.getElementById("alert-notification");
    if (Alertnotification) {
        ReactDOM.render(<AlertNotification title={title} type={type} meesage={message} />, Alertnotification);
    }
}